const options = {
    rootClass: 'zp-project-list',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);

    class ProjectList {

        /**
         * Konstruktor
         * @param {Selector} root
         */
        constructor(root) {
            this.start(root);
        }

        /**
         * foo
         * @param {Selector} root
         */
        start(root) {

            let bigProjects = $('#' + root.attr('id') + ' .zp-project-list_project-container-big .zp-project-list_project');
            let bigProjectsInner = $('#' + root.attr('id') + ' .zp-project-list_project-container-big .zp-project-list_project-inner');
            bigProjectsInner.addClass('visible');

            //Große Projekte
            bigProjects.each((index, project) => {

                let _project = $(project);

                this.scrollPositionOnBigProject(root, _project);

                $( window ).on( "scroll", ( )  => { this.scrollPositionOnBigProject(root, _project); });
                $( window ).on( "resize", ( )  => { this.scrollPositionOnBigProject(root, _project); });

            });

            //Kleine Projekte
            // this.changeSmallProjectHeight(root);
            // $( window ).on( "resize", () => {this.changeSmallProjectHeight(root); });


            let smallProjects = $('#' + root.attr('id') + ' .zp-project-list_project-container-small .zp-project-list_project');
            let delay;
            smallProjects.each((index, smallProject) => {

                delay = index*100;
                let _smallProject = $(smallProject);
                _smallProject.css('transition-delay', delay+'ms');

            });
            this.scrollPositionOnSmallProject(root);
            $( window ).on( "scroll", ( )  => { this.scrollPositionOnSmallProject(root); });
            $( window ).on( "resize", ( )  => { this.scrollPositionOnSmallProject(root); });

        }

        scrollPositionOnBigProject (root, _project) {

            let projectContainer = _project.parent();
            let projectHeight = _project.height();

            let scrollPositionTop = _w.scrollTop();
            let scrollPositionBottom = (_w.scrollTop()+_w.height());

            //Punkt, an dem das Projekt sichtbar und insichtbar wird definieren
            let projectVisibleFromProjectBottom = 600;
            let windowHeight = window.innerHeight;
            if (windowHeight <= 800) {
                projectVisibleFromProjectBottom = projectVisibleFromProjectBottom - (800-windowHeight);
                if (projectVisibleFromProjectBottom < 320) {
                    projectVisibleFromProjectBottom = 320;
                }
            }

            if (projectHeight-50 <= projectVisibleFromProjectBottom ) {
                projectVisibleFromProjectBottom = projectHeight-70-1;
            }
            console.log(projectHeight);
            console.log(projectVisibleFromProjectBottom);
            console.log('---');
            let projectOffset = parseInt(projectContainer.offset().top);
            let projectOffsetWithHeight = parseInt((projectContainer.offset().top+projectContainer.height()));


            //ist sichtbar
            if (_project.hasClass('visible')) {

                //beim hochscrollen
                if (projectOffset+70 > scrollPositionBottom) {
                    _project.addClass('hidden-from-bottom');
                    _project.removeClass('visible');
                }
                //beim herunterscrollen
                else if (projectOffsetWithHeight-50 < scrollPositionTop) {
                    _project.addClass('hidden-from-top');
                    _project.removeClass('visible');
                    // console.log(_project, projectOffsetWithHeight);
                }


            }
            //ist unsichtbar
            else {

                if (projectOffsetWithHeight-projectVisibleFromProjectBottom <= scrollPositionBottom && projectOffsetWithHeight-50 >= scrollPositionTop) {
                    _project.addClass('visible');
                    _project.removeClass('hidden-from-bottom');
                    _project.removeClass('hidden-from-top');
                    // console.log('2. MATCH');
                    // console.log('Scroll: '+(_w.scrollTop()+_w.height()));
                    // console.log('Projekt-Offset: '+projectOffset);
                }
                else {
                    
                }

            }

        }

        scrollPositionOnSmallProject (root) {

            let smallProjectsContainer = $('#' + root.attr('id') + ' .zp-project-list_small-projects');
            let smallProjects = $('#' + root.attr('id') + ' .zp-project-list_project-container-small .zp-project-list_project');

            let scrollPositionBottom = (_w.scrollTop()+_w.height());

            let smallProjectsContainerOffset = parseInt(smallProjectsContainer.offset().top);
            let smallProjectsContainerOffsetWidthHeight = parseInt(smallProjectsContainerOffset+smallProjectsContainer.height());


            //ist sichtbar
            if (smallProjectsContainer.hasClass('visible')) {

                if (smallProjectsContainerOffset+150 > scrollPositionBottom) {
                    smallProjectsContainer.addClass('hidden');
                    smallProjectsContainer.removeClass('visible');
                    smallProjects.addClass('hidden');
                    smallProjects.removeClass('visible');
                }
                else {

                }


            }
            //ist unsichtbar
            else {

                if (smallProjectsContainerOffset+150 <= scrollPositionBottom) {

                    smallProjectsContainer.addClass('visible');
                    smallProjectsContainer.removeClass('hidden');

                    smallProjects.each((index, smallProject) => {

                        let _smallProject = $(smallProject);
                        _smallProject.addClass('visible');
                        _smallProject.removeClass('hidden');

                    });
                }
                else {

                }

            }



        }

        changeSmallProjectHeight (root) {

            let smallProjects = $('#' + root.attr('id') + ' .zp-project-list_project-container-small');
            let firstSmallProject = $(smallProjects[0]);
            let firstSmallProjectWidth = firstSmallProject.width();

            smallProjects.height(firstSmallProjectWidth);

        }

    }

    return ProjectList;

}(window, document, jQuery)));